import React from 'react'
import formattedCreditsWithHoursShort from '@Utils/FormattedCreditsWithHoursShort'
import Plus from '@Images/projects_table_new_project_plus.svg'
import Button from '@SiteComponents/Button'

import './LabelsTableHeader.scss'

interface LabelsTableHeaderProps {
  readonly currentWorkspaceName: string
  readonly totalCountOfLabels: number
  readonly availableTotalCredits: number
  handleOpenCreateLabelPopup(): void
}

const LabelsTableHeader: React.FC<LabelsTableHeaderProps> = props => {
  const {
    currentWorkspaceName,
    totalCountOfLabels,
    availableTotalCredits,
  } = props

  const renderLabelsTableHeaderTop = () => {
    return (
      <div className="LabelsTableHeader__top">
        {renderLabelsTableHeaderTopLeft()}
        {renderLabelsTableHeaderTopRight()}
      </div>
    )
  }

  const renderLabelsTableHeaderTopLeft = () => {
    return (
      <div className="LabelsTableHeader__top-left">
        <div className="LabelsTableHeader__workspace-name">
          {currentWorkspaceName}
        </div>
        <div className="LabelsTableHeader__number-of-labels">
          {totalCountOfLabels === 1 ? '1 label' : `${totalCountOfLabels} labels`}
        </div>
      </div>
    )
  }

  const renderLabelsTableHeaderTopRight = () => {
    return (
      <div className="LabelsTableHeader__top-right">
        <div className="LabelsTableHeader__credits-remaining">
          {`${formattedCreditsWithHoursShort(availableTotalCredits)} credits remaining`}
        </div>
      </div>
    )
  }

  const renderLabelsTableHeaderBottom = () => {
    return (
      <div className="LabelsTableHeader__bottom">
        {renderNewLabelButton()}
      </div>
    )
  }

  const renderNewLabelButton = () => {
    return (
      <Button
        caption="New label"
        icon={<Plus />}
        onClick={props.handleOpenCreateLabelPopup}
        styleType="brand"
        size="large"
        iconRight
      />
    )
  }

  return (
    <div className="LabelsTableHeader">
      {renderLabelsTableHeaderTop()}
      {renderLabelsTableHeaderBottom()}
    </div>
  )
}

export default LabelsTableHeader
